import { apiFetch } from '@/lib/api/client';
import type { CurrentUser } from '@/types/api';

/**
 * The first authenticated call. A valid Google session is not the same as having
 * access — this is where the app finds out whether you are an active employee.
 */
export function fetchCurrentUser(): Promise<CurrentUser> {
  return apiFetch<CurrentUser>('/me');
}
